import { Capacitor } from '@capacitor/core';

// Détection de la plateforme pour conditionner les comportements natifs
// (push, auth native, caméra, deep links…) sans impacter la version web.

/** Vrai dans l'app native (iOS/Android) via Capacitor. */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/** 'ios' | 'android' | 'web'. */
export const getPlatform = (): string => Capacitor.getPlatform();

export const isIOS = (): boolean => Capacitor.getPlatform() === 'ios';
export const isAndroid = (): boolean => Capacitor.getPlatform() === 'android';

/** Vrai si le bundle a été construit pour l'app (REACT_APP_TARGET=app). */
export const isAppTarget = (): boolean => process.env.REACT_APP_TARGET === 'app';

/** Vrai dans l'app native OU dans un build ciblé app. */
export const isApp = (): boolean => isAppTarget() || isNative();
